import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initCardRollAnimation() {

    // ---------------------------------------
    // 1) Pin .pinned-content
    // ---------------------------------------
    ScrollTrigger.create({
        trigger: ".scroll-trigger-container",
        start: "top top",
        end: "bottom bottom",
        pin: ".pinned-content",
        pinSpacing: false // set to true if spacing is needed
    });

    // ---------------------------------------
    // 2) Step-by-step rotation of the wheel
    // ---------------------------------------

    // Collect .scroll-trigger-item elements
    const triggerItems = gsap.utils.toArray(".scroll-trigger-item");

    const contentItems = gsap.utils.toArray(".content-items .item");

    ScrollTrigger.matchMedia({
        // Desktop (>= 768px)
        "(min-width: 768px)": function() {
            // Initial rotate
            gsap.set(".rotate-cards", { x: "91%", y: "-50%", rotate: -12, force3D: true, xPercent: 0, yPercent: 0});

            // For each of the 3 .scroll-trigger-item elements,
            // define rotation values in [startRot, midRot, endRot] for (top->center, center->bottom).
            const rotationSteps = [
                [-12, -8, -4],  // For the first .scroll-trigger-item
                [-4,  0,   4],  // For the second
                [4,   8,   12]  // For the third
            ];

            triggerItems.forEach((block, i) => {
                if (!rotationSteps[i]) return;
                const [startRot, midRot, endRot] = rotationSteps[i];

                // (a) top center → center center: from startRot to midRot
                gsap.fromTo(
                    ".rotate-cards",
                    {
                        rotate: startRot,
                    },
                    {
                        rotate: midRot,
                        immediateRender: false,
                        scrollTrigger: {
                            trigger: block,
                            start: "top center",
                            end: "center center",
                            scrub: true
                        }
                    }
                );

                // (b) center center → bottom center: from midRot to endRot
                gsap.fromTo(
                    ".rotate-cards",
                    {
                        rotate: midRot,
                    },
                    {
                        rotate: endRot,
                        immediateRender: false,
                        scrollTrigger: {
                            trigger: block,
                            start: "center center",
                            end: "bottom center",
                            scrub: true
                        }
                    }
                );
            });

            // ---------------------------------------
            // 3) Fade in/out each .content-items .item
            // ---------------------------------------

            triggerItems.forEach((triggerBlock, index) => {
                if (!contentItems[index]) return;

                gsap.timeline({
                    scrollTrigger: {
                        trigger: triggerBlock,
                        start: "top center",
                        end: "bottom center",
                        scrub: true
                    }
                })
                    .fromTo(
                        contentItems[index],
                        { opacity: 0 },
                        { opacity: 1, duration: 0.1 }
                    )
                    .to(
                        contentItems[index],
                        { opacity: 0, duration: 0.1 }
                    );
            });
        },
        "(max-width: 767px)": function() {
            // Initial rotate
            gsap.set(".rotate-cards", { x: 0, y: 0, rotate: 0, force3D: true, xPercent: 0, yPercent: 0});

            const cards = gsap.utils.toArray(".rotate-cards .card");

            let n = 3;

            triggerItems.forEach((triggerBlock, index) => {
                if (!cards[index]) return;
                n--;

                let scale = 1 - n * 0.1;
                let top = -1 * ((16 * n) + 8);

                if (index === 0) {
                    // For the first card, always keep it visible
                    gsap.set(cards[index], { opacity: 1 });

                    gsap.timeline({
                        scrollTrigger: {
                            trigger: triggerBlock,
                            start: "center center",
                            end: "bottom center",
                            scrub: true
                        }
                    })
                        .fromTo(
                            cards[index],
                            { opacity: 1, scale: 1 },
                            { opacity: 1, y: top, scale: scale, duration: 0.1 }
                        );
                } else if (index === 2) {
                    gsap.timeline({
                        scrollTrigger: {
                            trigger: triggerBlock,
                            start: "top center",
                            // end: "bottom center",
                            end: "+=50%",
                            scrub: true
                        }
                    })
                        .fromTo(
                            cards[index],
                            { opacity: 0, scale: 1.2 },
                            { opacity: 1, y: 0, scale: 1, duration: 0.1 }
                        );
                } else {
                    // For subsequent cards, animate opacity along with the text
                    gsap.timeline({
                        scrollTrigger: {
                            trigger: triggerBlock,
                            start: "top center",
                            end: "bottom center",
                            scrub: true
                        }
                    })
                        .fromTo(
                            cards[index],
                            { opacity: 0, scale: 1.2 },
                            { opacity: 1, y: 0, scale: 1, duration: 0.1 }
                        )
                        .to(
                            cards[index],
                            { opacity: 1, y: top, scale: scale, duration: 0.1 }
                        );
                }
            });


            triggerItems.forEach((triggerBlock, index) => {
                if (!contentItems[index]) return;


                if (index === 0) {

                    gsap.set(contentItems[index], { opacity: 1 });

                    gsap.timeline({
                        scrollTrigger: {
                            trigger: triggerBlock,
                            start: "center center",
                            end: "bottom center",
                            scrub: true
                        }
                    })
                        .to(
                            contentItems[index],
                            { opacity: 0, duration: 0.1 }
                        );
                } else if (index === 2) {
                    gsap.timeline({
                        scrollTrigger: {
                            trigger: triggerBlock,
                            start: "top center",
                            // end: "bottom center",
                            end: "+=50%",
                            scrub: true
                        }
                    })
                        .fromTo(
                            contentItems[index],
                            { opacity: 0 },
                            { opacity: 1, duration: 0.1 }
                        );
                } else {
                    gsap.timeline({
                        scrollTrigger: {
                            trigger: triggerBlock,
                            start: "top center",
                            end: "bottom center",
                            scrub: true,
                        }
                    })
                        .fromTo(
                            contentItems[index],
                            { opacity: 0 },
                            { opacity: 1, duration: 0.1 }
                        )
                        .to(
                            contentItems[index],
                            { opacity: 0, duration: 0.1 }
                        );
                }
            });
        },
    });

    gsap.set(contentItems, { pointerEvents: "none" });



    triggerItems.forEach((triggerBlock, index) => {
        if (!contentItems[index]) return;

        ScrollTrigger.create({
            trigger: triggerBlock,
            start: "top center",
            end: "bottom center",
            onEnter: () => gsap.set(contentItems[index], { pointerEvents: "auto" }),
            onEnterBack: () => gsap.set(contentItems[index], { pointerEvents: "auto" }),
            onLeave: () => gsap.set(contentItems[index], { pointerEvents: "none" }),
            onLeaveBack: () => gsap.set(contentItems[index], { pointerEvents: "none" })
        });
    });

    // ---------------------------------------
    // 4) Activate/deactivate dots (.pinned-dots .dot)
    // ---------------------------------------
    // At "top center" - add the 'active' class,
    // at "bottom center" - remove it, via toggleClass.
    const dots = gsap.utils.toArray(".pinned-dots .dot");
    const cards = gsap.utils.toArray(".section-card-roll .card");

    triggerItems.forEach((block, i) => {
        // if (!dots[i]) return;
        if (!dots[i] || !cards[i]) return;

        ScrollTrigger.create({
            trigger: block,
            start: "top center",
            end: "bottom center",
            // toggleClass automatically adds/removes 'active'
            // onEnter/onLeave and onEnterBack/onLeaveBack.
            toggleClass: {
                // targets: dots[i],
                targets: [dots[i], cards[i]],
                className: "active"
            }
        });
    });
}

// Initialize on document ready
$(document).ready(function(){
    initCardRollAnimation();
});

$(window).on("resize", function(){
    ScrollTrigger.refresh();
});